import React from 'react';
import Paragraph, { sizeOptions } from "../Paragraph/paragraph"


const Lead = ({ children, className }) => (
  <Paragraph size={sizeOptions.large} className={className}>{children}</Paragraph>
)

export default Lead;
